<div class="col-lg-12">
    <div class="card">
        <div class="card-header">
            {{ title | translate}}
        </div>
        <div class="card-body">
            <form [formGroup]="productConditionForm" (ngSubmit)="submitForm()" novalidate>
                <input type="hidden" formControlName="id">
                <div class="form-group">
                    <label>{{'conditions.french_name' | translate}} <span class="require-star">*</span></label>
                    <input type="text" formControlName="descriptionFr" class="form-control">
                    <em *ngIf="(f.descriptionFr.touched && f.descriptionFr.invalid)" class="text-danger">
                        {{'common.description_required' | translate}}
                    </em>
                </div>
                <div class="form-group">
                    <label>{{'conditions.english_name' | translate}} <span class="require-star">*</span></label>
                    <input type="text" formControlName="description" class="form-control">
                    <em *ngIf="(f.description.touched && f.description.invalid)" class="text-danger">
                        {{'common.description_required' | translate}}
                    </em>
                </div>
                <div class="form-group">
                    <label>{{'common.status' | translate}} <span class="require-star">*</span></label>
                    <input type="text" formControlName="status" class="form-control">
                    <em *ngIf="(f.status.touched && f.status.invalid)" class="text-danger">
                        {{'common.status_required' | translate}}
                    </em>
                </div>
                <div class="buttons-set mt-3">
                    <button class="button button-submit" type="submit"
                            [disabled]="!productConditionForm.dirty || productConditionForm.invalid ">
                        <span>{{ (submitted ? 'common.wait' : 'common.submit') | translate }}</span> <span *ngIf="submitted"> ...</span>
                    </button>
                    <span class="ml-2"></span>
                    <a class="button button-back" (click)="back_to_previous()">
                        <span>{{'common.back' | translate}}</span>
                    </a>
                </div>
            </form>
        </div>
    </div>
</div>
